import {ellipsis} from 'polished';
import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {Icon, IconName} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {center} from '../../../../../libs/shared/ui/src/styles/mixins';
import {SwitcherItem, SwitcherItemProps} from './switcherItem';

/*
 * Props.
 */

interface IconSwitcherItemProps extends SwitcherItemProps {
  iconName: IconName;
  label?: React.ReactNode;
  isNewIntDiscoveryEnabled?: boolean;
}

/*
 * Style.
 */

interface IconStyleProps {
  $isSelected: boolean;
  $isNewIntDiscoveryEnabled?: boolean;
}
const StyledIconDiv = styled.div<IconStyleProps>`
  width: 100%;
  height: 100%;
  ${center()};

  color: ${(p) => (p.$isNewIntDiscoveryEnabled ? p.theme.greys.white : p.theme.greys.shade60)};
  background: ${(p) => (p.$isNewIntDiscoveryEnabled ? p.theme.palette.blue.shade40 : 'unset')};
  ${(p) => maybeAddSelectedStyle(p.$isSelected, p.$isNewIntDiscoveryEnabled)};
`;

function maybeAddSelectedStyle(isSelected: boolean, isNewIntDiscoveryEnabled?: boolean) {
  if (!isSelected) {
    return css`
      &:hover {
        color: ${(p) => (isNewIntDiscoveryEnabled ? p.theme.greys.white : p.theme.greys.shade70)};
        background: ${(p) => (isNewIntDiscoveryEnabled ? p.theme.palette.blue.shade50 : 'unset')};
      }
    `;
  }

  if (isNewIntDiscoveryEnabled) {
    return css`
      background: ${(p) => p.theme.greys.black};
    `;
  }

  return css`
    color: ${(p) => p.theme.greys.white};
    background-color: ${(p) => p.theme.palette.blue.shade40};
  `;
}

const StyledIconSwitcherWrapperDiv = styled.div`
  display: flex;
  flex-flow: column;
  gap: 4px;
`;

const StyledLabelWrapperDiv = styled.div`
  font-size: 9px;
  color: ${(p) => p.theme.greys.shade80};
  font-weight: ${fontWeights.light};
  text-align: center;
  width: 100%;
  margin-top: 4px;
  ${ellipsis()};
`;

/*
 * Component.
 */

export const IconSwitcherItem: FC<IconSwitcherItemProps> = (props) => (
  <StyledIconSwitcherWrapperDiv>
    <SwitcherItem {...props}>
      <StyledIconDiv
        $isSelected={Boolean(props.isSelected)}
        $isNewIntDiscoveryEnabled={props.isNewIntDiscoveryEnabled}
      >
        <Icon name={props.iconName} />
      </StyledIconDiv>
    </SwitcherItem>
    {props.label && <StyledLabelWrapperDiv>{props.label}</StyledLabelWrapperDiv>}
  </StyledIconSwitcherWrapperDiv>
);
